define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def",
	"csi/def/Field",
	"csi/reflection",
	"csi/table/AggregateFrom",
	"csi/xml"
], function(declare,lang,def,Field,reflection,AggregateFrom,xml) {

	var DEFINITION = "Definition";
	var DEFINITION_FORM_ID = "SpecificationItemDefinition";
	var DESCRIPTION = "Description";

	return declare(AggregateFrom, {
		/**
		 * Combine the SDI form
		 * Handle the Description attribute from two forms(SDI&SSI)
		 * Set the default values for the attributes from the SDI form
		 * @param {csi.view.Widget} view
		 */
		onCreatePopup: function(view) {
			this.inherited(arguments);

			if (view.defView.m_id == def.DEFAULT_FORM_ID) {
				// add the description attribute of the SSI form by default if not exist
				if (!view.getField(DESCRIPTION)) {
					var f = lang.mixin(new Field(), {
						m_id: DESCRIPTION
					});

					view.insertField(f, 0);
				}

				view.getField(DEFINITION).bHidden = true;
				view.combineForm(true, DEFINITION, null, { m_right: xml.RIGHT_NONE });

				// check if description attribute of the SDI form exist, if it does, remove it
				view.defView.removeField(view.getCombinedFieldName(DEFINITION_FORM_ID, DESCRIPTION));

				view.addFixedValue(DESCRIPTION, this.m_formData.getSelectedNode().Description);
			}
		}
	});
});